import { BrandState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";
const default_page_size = Number(`${process.env.REACT_APP_PAGE_SIZE}`);
const initialState: BrandState = {
  brands: [],
  brand: null,
  loading: true,
  refreshLoader: false,
  filter: { page: 1, pageSize: default_page_size },
  count: 0,
  refresh: 0,
  brandMap: {},
  brandOptions: [],
};

export const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setBrand: (state, action) => {
      state.brand = action.payload;
    },
    setBrands: (
      state,
      action: PayloadAction<{ brands: any[]; count: number }>
    ) => {
      const { brands, count } = action.payload;
      state.brands = brands;
      state.count = count;
      state.refreshLoader = false;
      let options: SelectOption[] = [];

      brands?.forEach(({ _id, name }: any) =>
        options.push({ value: _id, label: name })
      );
      state.brands = brands;
      state.brandOptions = options;
    },
    setFilter: (state, action) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filter = { ...initialState.filter, ...action.payload };
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filter.page = action.payload;
    },
    resetPage: (state) => {
      state.filter.page = 1;
    },

    addBrand: (state, action) => {
      state.brands.push(action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    filterBrand: (state, action) => {
      const id = action.payload;
      state.brands = state.brands.filter(({ _id }) => _id !== id);
    },

    updateBrand: (state, action) => {
      const { id, brand } = action.payload;
      state.brands.every(({ _id }, i) => {
        if (id === _id) {
          state.brands[i] = brand;
          return false;
        }
        return true;
      });
    },
  },
});

const brandReducer = brandSlice.reducer;
export const brandActions = brandSlice.actions;
export default brandReducer;
